export default __webpack_public_path__ + "static/media/icon-swapFree.70d71a02.svg";